module.exports = __webpack_public_path__ + "static/event-1-6478a8f6de08295a68f64c6071612cde.gif";